// ./../common/SetsButton.jsx
import React from "react";
import PropTypes from "prop-types";

const SetsButton = ({ onClick, label }) => {
  return (
    <button
      className="common-button sets-button"
      onClick={onClick}
      disabled={typeof label === "number"} // Disable when showing set count
      style={{
        cursor: typeof label === "number" ? "default" : "pointer",
      }}
    >
      {typeof label === "number" ? `${label}` : "+"}
    </button>
  );
};

SetsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default SetsButton;
